import { useTheme } from '@mui/material';
import React from 'react';

const NotFoundTheme: React.FC = (props: any) => {
	const {
		palette: {
			illustrationAccent,
			primary: { dark: primaryDark, light: primaryLight }
		}
	} = useTheme();

	return (
		<svg
			width="300"
			height="300"
			viewBox="0 0 300 300"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M146.428 107.082C147.156 105.828 148.2 104.787 149.457 104.064C150.714 103.341 152.138 102.96 153.589 102.96C155.038 102.96 156.462 103.341 157.718 104.064C158.975 104.787 160.02 105.828 160.748 107.082L209.126 190.877C209.847 192.135 210.223 193.56 210.22 195.009C210.216 196.459 209.832 197.882 209.105 199.136C208.378 200.39 207.337 201.432 206.08 202.157C204.825 202.881 203.401 203.263 201.952 203.264H105.196C103.749 203.257 102.329 202.872 101.078 202.145C99.8264 201.418 98.7874 200.376 98.0645 199.123C97.3415 197.87 96.9596 196.448 96.957 195.002C96.9544 193.554 97.3312 192.132 98.0497 190.877L146.428 107.082ZM153.574 173.637C153.212 173.638 152.853 173.57 152.518 173.431C152.184 173.293 151.88 173.09 151.623 172.835C151.368 172.579 151.165 172.276 151.027 171.94C150.89 171.605 150.822 171.247 150.823 170.885V130.702C150.823 129.973 151.113 129.273 151.629 128.757C152.144 128.241 152.844 127.951 153.574 127.951C154.304 127.951 155.003 128.241 155.518 128.757C156.035 129.273 156.324 129.973 156.324 130.702V170.885C156.323 171.614 156.033 172.313 155.518 172.829C155.002 173.346 154.304 173.635 153.574 173.637ZM156.778 182.936C156.778 184.707 155.344 186.141 153.574 186.141C151.804 186.141 150.369 184.707 150.369 182.936C150.369 181.166 151.804 179.732 153.574 179.732C155.344 179.732 156.778 181.166 156.778 182.936Z"
				fill={primaryLight}
			/>
			<path
				d="M63.7312 84.2971C65.6889 84.2971 67.2759 82.7102 67.2759 80.7525C67.2759 78.7949 65.6889 77.2078 63.7312 77.2078C61.7735 77.2078 60.1865 78.7949 60.1865 80.7525C60.1865 82.7102 61.7735 84.2971 63.7312 84.2971Z"
				fill={illustrationAccent}
			/>
			<path
				d="M231.387 99.0549L230.961 108.67L194.097 124.747L194.494 115.134L231.387 99.0549Z"
				fill={illustrationAccent}
			/>
			<path
				d="M229.997 132.036L229.6 141.648L192.707 157.728L193.132 148.142L229.997 132.036Z"
				fill={illustrationAccent}
			/>
			<path
				d="M85.2886 162.774L84.8916 172.36L49.9268 187.615V178.201L85.2886 162.774Z"
				fill={illustrationAccent}
			/>
			<path
				d="M83.9274 195.756L83.5304 205.369L52.876 218.725C51.9415 217.831 51.1982 216.757 50.6914 215.567C50.1844 214.378 49.9242 213.097 49.9268 211.804V210.585L83.9274 195.756Z"
				fill={illustrationAccent}
			/>
			<path
				d="M112.285 151.318L104.458 156.906L69.125 137.678L76.9517 132.093L112.285 151.318Z"
				fill={illustrationAccent}
			/>
			<path
				d="M68.9576 93.9506L61.1309 99.537C50.2357 93.6297 52.3863 94.8013 49.9297 93.4402V83.6001L68.9576 93.9506Z"
				fill={illustrationAccent}
			/>
			<path
				d="M257.249 196.35V206.19L236.009 194.648L243.835 189.062L257.249 196.35Z"
				fill={illustrationAccent}
			/>
			<path
				d="M241.198 221.419H223.106L209.126 213.819L216.953 208.233L241.198 221.419Z"
				fill={illustrationAccent}
			/>
			<path
				d="M287.591 147.605C288.484 147.605 289.207 146.881 289.207 145.988C289.207 145.096 288.484 144.372 287.591 144.372C286.698 144.372 285.975 145.096 285.975 145.988C285.975 146.881 286.698 147.605 287.591 147.605Z"
				fill={illustrationAccent}
			/>
			<path
				d="M133.667 129.142L129.356 136.657L96.0078 118.508L103.834 112.923L133.667 129.142Z"
				fill={illustrationAccent}
			/>
			<path
				d="M208.502 169.835L200.675 175.422L199.966 175.026L191.686 160.706L208.502 169.835Z"
				fill={illustrationAccent}
			/>
			<path
				d="M257.248 76.569C257.248 210.472 257.572 214.206 256.651 215.125C255.971 216.97 254.743 218.562 253.131 219.688C251.519 220.813 249.599 221.418 247.634 221.421H59.5116C56.97 221.419 54.5331 220.409 52.7358 218.612C50.9387 216.815 49.9284 214.378 49.9268 211.836V76.569C49.9284 74.0275 50.9387 71.5904 52.7358 69.7932C54.5331 67.9961 56.97 66.9857 59.5116 66.9842H247.635C248.896 66.9796 250.146 67.2242 251.313 67.704C252.48 68.1837 253.54 68.8891 254.434 69.7796C255.326 70.6702 256.035 71.7284 256.517 72.8936C257.001 74.0586 257.25 75.3077 257.248 76.569Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M241.879 94.4329H69.749"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M63.7312 84.2971C65.6889 84.2971 67.2759 82.7102 67.2759 80.7525C67.2759 78.7949 65.6889 77.2078 63.7312 77.2078C61.7735 77.2078 60.1865 78.7949 60.1865 80.7525C60.1865 82.7102 61.7735 84.2971 63.7312 84.2971Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M74.4558 84.2822C76.4135 84.2822 78.0005 82.6953 78.0005 80.7376C78.0005 78.7798 76.4135 77.1929 74.4558 77.1929C72.4981 77.1929 70.9111 78.7798 70.9111 80.7376C70.9111 82.6953 72.4981 84.2822 74.4558 84.2822Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M85.2039 84.2822C87.1616 84.2822 88.7486 82.6953 88.7486 80.7376C88.7486 78.7798 87.1616 77.1929 85.2039 77.1929C83.2462 77.1929 81.6592 78.7798 81.6592 80.7376C81.6592 82.6953 83.2462 84.2822 85.2039 84.2822Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M111.548 160.761L84.8916 172.388L85.2886 162.774L101.906 155.515L111.548 160.761Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M231.387 99.0552L230.961 108.67L194.097 124.747L194.494 115.134L231.387 99.0552Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M229.997 132.036L229.6 141.648L192.707 157.728L193.132 148.142L229.997 132.036Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M85.2886 162.774L84.8916 172.361L49.9268 187.616V178.201L85.2886 162.774Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M257.248 87.7688V97.185L230.961 108.67L231.386 99.0551L257.248 87.7688Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M257.248 120.154V129.596L229.6 141.648L229.997 132.036L257.248 120.154Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M83.9274 195.756L83.5304 205.369L52.876 218.725C51.9415 217.831 51.1982 216.757 50.6914 215.567C50.1844 214.378 49.9242 213.097 49.9268 211.804V210.585L83.9274 195.756Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M211.026 39.0938H190.297"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M103.551 260.92C105.508 260.92 107.095 259.333 107.095 257.375C107.095 255.417 105.508 253.83 103.551 253.83C101.593 253.83 100.006 255.417 100.006 257.375C100.006 259.333 101.593 260.92 103.551 260.92Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M103.834 112.923L96.0077 118.508L61.1279 99.5369L68.9546 93.9504L103.834 112.923Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M243.835 189.062L236.008 194.648L200.675 175.422L208.501 169.835L243.835 189.062Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M76.9515 132.093L69.1248 137.678L49.9268 127.244V117.402L76.9515 132.093Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M112.285 151.318L104.458 156.906L69.125 137.678L76.9517 132.093L112.285 151.318Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M68.9576 93.9508L61.1309 99.5373C50.2357 93.6299 52.3863 94.8016 49.9297 93.4404V83.6003L68.9576 93.9508Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M257.249 196.35V206.19L236.009 194.648L243.835 189.062L257.249 196.35Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M241.198 221.419H223.106L209.126 213.819L216.953 208.233L241.198 221.419Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M146.428 107.082C147.156 105.828 148.2 104.787 149.457 104.064C150.714 103.341 152.138 102.96 153.589 102.96C155.038 102.96 156.462 103.341 157.718 104.064C158.975 104.787 160.02 105.828 160.748 107.082L209.126 190.877C209.847 192.135 210.223 193.56 210.22 195.009C210.216 196.459 209.832 197.882 209.105 199.136C208.378 200.39 207.337 201.432 206.08 202.157C204.825 202.881 203.401 203.263 201.952 203.264H105.196C103.749 203.257 102.329 202.872 101.078 202.145C99.8264 201.418 98.7874 200.376 98.0645 199.123C97.3415 197.87 96.9596 196.448 96.957 195.002C96.9544 193.554 97.3312 192.132 98.0497 190.877L146.428 107.082Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M153.573 173.637C153.212 173.638 152.852 173.568 152.518 173.431C152.183 173.294 151.879 173.091 151.622 172.835C151.367 172.579 151.164 172.274 151.027 171.94C150.889 171.606 150.821 171.246 150.822 170.885V130.702C150.822 129.972 151.112 129.273 151.628 128.757C152.143 128.241 152.843 127.951 153.573 127.951C154.303 127.951 155.003 128.241 155.518 128.757C156.034 129.273 156.324 129.972 156.324 130.702V170.885C156.322 171.615 156.033 172.313 155.518 172.829C155.001 173.344 154.303 173.635 153.573 173.637Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M153.574 186.141C155.344 186.141 156.778 184.707 156.778 182.937C156.778 181.166 155.344 179.732 153.574 179.732C151.803 179.732 150.369 181.166 150.369 182.937C150.369 184.707 151.803 186.141 153.574 186.141Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M287.591 117.827V137.678"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5142 77.533L8.21289 98.219H25.0856L15.8127 118.878"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M276.645 206.048V215.124H256.646C257.056 214.079 257.259 212.963 257.243 211.84V206.055L276.645 206.048Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M291.788 210.585C291.785 219.082 288.746 227.297 283.218 233.75C277.691 240.202 270.039 244.468 261.643 245.775C253.25 247.083 244.663 245.347 237.435 240.881C230.207 236.414 224.813 229.513 222.227 221.419H247.635C250.178 221.415 252.617 220.404 254.418 218.609C256.22 216.812 257.236 214.376 257.248 211.833V174.968C266.505 175.252 275.288 179.128 281.736 185.777C288.183 192.426 291.789 201.324 291.788 210.585Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M194.493 115.134L194.096 124.747L175.607 132.829L171.24 125.287L194.493 115.134Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M193.132 148.142L192.707 157.728L190.523 158.691L186.185 151.148L193.132 148.142Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M133.667 129.142L129.356 136.657L96.0078 118.508L103.834 112.923L133.667 129.142Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M208.502 169.835L200.675 175.422L199.966 175.026L191.686 160.706L208.502 169.835Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M216.953 208.233L209.126 213.819L189.724 203.27H201.946C203.344 203.275 204.719 202.923 205.944 202.25L216.953 208.233Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M98.0493 190.877C97.3225 192.118 96.9346 193.529 96.9246 194.968C96.9147 196.406 97.2829 197.821 97.9926 199.074L83.5303 205.397L83.9273 195.783L99.0418 189.204L98.0493 190.877Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M118.835 154.863L114.497 162.377L104.458 156.906L112.285 151.318L118.835 154.863Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default NotFoundTheme;
